var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.paramsData.id !== "" ? _vm.$t("modify") : _vm.$t("add"),
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "user_id", label: _vm.$t("roleId") }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("pleaseInputRoleId") },
                    model: {
                      value: _vm.paramsData.user_id,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "user_id", $$v)
                      },
                      expression: "paramsData.user_id"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "device_id", label: _vm.$t("deviceId") }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("pleaseInputDeviceId") },
                    model: {
                      value: _vm.paramsData.device_id,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "device_id", $$v)
                      },
                      expression: "paramsData.device_id"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "welfare_level_id",
                    label: _vm.$t("benefitLevel")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        prop: "label",
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      model: {
                        value: _vm.paramsData.welfare_level_id,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "welfare_level_id", $$v)
                        },
                        expression: "paramsData.welfare_level_id"
                      }
                    },
                    _vm._l(_vm.gmWelfareLevelListsList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "input", label: _vm.$t("accountOwner") }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("pleaseInputAccountOwner") },
                    model: {
                      value: _vm.paramsData.input,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "input", $$v)
                      },
                      expression: "paramsData.input"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { label: "IP" } },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("pleaseInputIp") },
                    model: {
                      value: _vm.paramsData.ip,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "ip", $$v)
                      },
                      expression: "paramsData.ip"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  staticStyle: { width: "100%" },
                  attrs: { prop: "textarea", label: _vm.$t("remark") }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: {
                      type: "textarea",
                      placeholder: _vm.$t("pleaseInputRemark")
                    },
                    model: {
                      value: _vm.paramsData.textarea,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "textarea", $$v)
                      },
                      expression: "paramsData.textarea"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: { click: _vm.dataFormSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }